import { render, staticRenderFns } from "./CarouselList.vue?vue&type=template&id=8b1840c8&scoped=true&"
import script from "./CarouselList.vue?vue&type=script&lang=js&"
export * from "./CarouselList.vue?vue&type=script&lang=js&"
import style0 from "./CarouselList.vue?vue&type=style&index=0&id=8b1840c8&lang=scss&scoped=true&"
import style1 from "./CarouselList.vue?vue&type=style&index=1&id=8b1840c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1840c8",
  null
  
)

export default component.exports